module.exports = __webpack_public_path__ + "img/icon_cruise_head_1.72b1e91.png";